import { render, staticRenderFns } from "./BasePreloaderSkeleton.vue?vue&type=template&id=f9454540&scoped=true&"
import script from "./BasePreloaderSkeleton.vue?vue&type=script&lang=js&"
export * from "./BasePreloaderSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./BasePreloaderSkeleton.vue?vue&type=style&index=0&id=f9454540&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9454540",
  null
  
)

export default component.exports